
<div class="service-area-container w-full flex flex-col justify-center items-center font-rubik bg-themeComponentBg-light">
  <div class="flex flex-col w-full max-w-1216">
    <div class="flex flex-wrap justify-between gap-4 w-full">
      <!-- Container Sales -->
      <a
        v-if="getSolutionByLinkType('sales')"
        :href="linkPath('sales')"
        class="card-wrapper"
      >
        <div class="service-area-cards card-sales">
          <div class="image-container">
            <img class="primary-image" src="@/images/service-area-cards/container-sales.png" alt="Container Sales">
            <img class="hover-image" src="@/images/service-area-cards/hover-state/hover-sales.svg" alt="Container Sales">
          </div>
          <div class="flex flex-col gap-2">
            <h3>Container Sales</h3>
            <div v-html="getSolutionByLinkType('sales').html_content" class="card-description"></div>
          </div>
          <div class="flex justify-start items-center">
            <span>Learn more</span>
            <div class="arrow-container">
              <img class="default-arrow" src="@/images/service-area-cards/Arrow.png" alt="Arrow">
              <img class="hover-arrow" src="@/images/service-area-cards/forward-arrows/container-sales.png" alt="Arrow">
            </div>
          </div>
        </div>
      </a>

      <!-- Container Rentals -->
      <a
        v-if="getSolutionByLinkType('rentals')"
        :href="linkPath('rentals')"
        class="card-wrapper"
      >
        <div class="service-area-cards card-rentals">
          <div class="image-container">
            <img class="primary-image" src="@/images/service-area-cards/container-rentals.png" alt="Container Rentals">
            <img class="hover-image" src="@/images/service-area-cards/hover-state/hover-rentals.svg" alt="Container Rentals">
          </div>
          <div class="flex flex-col gap-2">
            <h3>Container Rentals</h3>
            <div v-html="getSolutionByLinkType('rentals').html_content" class="card-description"></div>
          </div>
          <div class="flex justify-start items-center">
            <span>Learn more</span>
            <div class="arrow-container">
              <img class="default-arrow" src="@/images/service-area-cards/Arrow.png" alt="Arrow">
              <img class="hover-arrow" src="@/images/service-area-cards/forward-arrows/container-rentals.png" alt="Arrow">
            </div>
          </div>
        </div>
      </a>

      <!-- Refrigerated Containers -->
      <a
        v-if="getSolutionByLinkType('refrigerated')"
        :href="linkPath('refrigerated')"
        class="card-wrapper"
      >
        <div class="service-area-cards card-refrigerated">
          <div class="image-container">
            <img class="primary-image" src="@/images/service-area-cards/refrigerated-containers.png" alt="Refrigerated Containers">
            <img class="hover-image" src="@/images/service-area-cards/hover-state/hover-conditioning.svg" alt="Refrigerated Containers">
          </div>
          <div class="flex flex-col gap-2">
            <h3>Refrigerated Containers</h3>
            <div v-html="getSolutionByLinkType('refrigerated').html_content" class="card-description"></div>
          </div>
          <div class="flex justify-start items-center">
            <span>Learn more</span>
            <div class="arrow-container">
              <img class="default-arrow" src="@/images/service-area-cards/Arrow.png" alt="Arrow">
              <img class="hover-arrow" src="@/images/service-area-cards/forward-arrows/refrigerated-containers.png" alt="Arrow">
            </div>
          </div>
        </div>
      </a>

      <!-- Portable Offices -->
      <a
        v-if="getSolutionByLinkType('portable')"
        :href="linkPath('portable')"
        class="card-wrapper"
      >
        <div class="service-area-cards card-portable-offices">
          <div class="image-container">
            <img class="primary-image" src="@/images/service-area-cards/portable-offices.png" alt="Portable Offices">
            <img class="hover-image" src="@/images/service-area-cards/hover-state/hover-portable-offices.svg" alt="Portable Offices">
          </div>
          <div class="flex flex-col gap-2">
            <h3>Portable Offices</h3>
            <div v-html="getSolutionByLinkType('portable').html_content" class="card-description"></div>
          </div>
          <div class="flex justify-start items-center">
            <span>Learn more</span>
            <div class="arrow-container">
              <img class="default-arrow" src="@/images/service-area-cards/Arrow.png" alt="Arrow">
              <img class="hover-arrow" src="@/images/service-area-cards/forward-arrows/portable-offices.png" alt="Arrow">
            </div>
          </div>
        </div>
      </a>

      <!-- Container Modifications -->
      <a
        v-if="getSolutionByLinkType('modifications')"
        :href="linkPath('modifications')"
        class="card-wrapper"
      >
        <div class="service-area-cards card-modifications">
          <div class="image-container">
            <img class="primary-image" src="@/images/service-area-cards/container-modifications.png" alt="Container Modifications">
            <img class="hover-image" src="@/images/service-area-cards/hover-state/hover-modifications.svg" alt="Container Modifications">
          </div>
          <div class="flex flex-col gap-2">
            <h3>Container Modifications</h3>
            <div v-html="getSolutionByLinkType('modifications').html_content" class="card-description"></div>
          </div>
          <div class="flex justify-start items-center">
            <span>Learn more</span>
            <div class="arrow-container">
              <img class="default-arrow" src="@/images/service-area-cards/Arrow.png" alt="Arrow">
              <img class="hover-arrow" src="@/images/service-area-cards/forward-arrows/container-modifications.png" alt="Arrow">
            </div>
          </div>
        </div>
      </a>

      <!-- Refrigerated Container Rentals -->
      <a
        v-if="getSolutionByLinkType('refrigerated-container-rentals')"
        :href="linkPath('refrigerated-container-rentals')"
        class="card-wrapper"
      >
        <div class="service-area-cards card-refrigerated-rentals">
          <div class="image-container">
            <img class="primary-image" src="@/images/service-area-cards/refrigerated-containers.png" alt="Refrigerated Container Rentals">
            <img class="hover-image" src="@/images/service-area-cards/hover-state/hover-conditioning.svg" alt="Refrigerated Container Rentals">
          </div>
          <div class="flex flex-col gap-2">
            <h3>Refrigerated Container Rentals</h3>
            <div v-html="getSolutionByLinkType('refrigerated-container-rentals').html_content" class="card-description"></div>
          </div>
          <div class="flex justify-start items-center">
            <span>Learn more</span>
            <div class="arrow-container">
              <img class="default-arrow" src="@/images/service-area-cards/Arrow.png" alt="Arrow">
              <img class="hover-arrow" src="@/images/service-area-cards/forward-arrows/refrigerated-containers.png" alt="Arrow">
            </div>
          </div>
        </div>
      </a>

      <!-- CA Accessories -->
      <a
        v-if="getSolutionByLinkType('accessories')"
        :href="linkPath('accessories')"
        class="card-wrapper"
      >
        <div class="service-area-cards card-accessories">
          <div class="image-container">
            <img class="primary-image" src="@/images/service-area-cards/container-accessories.png" alt="Container Accessories">
            <img class="hover-image" src="@/images/service-area-cards/tags/container-accessories.png" alt="Container Accessories">
          </div>
          <div class="flex flex-col gap-2">
            <h3>Container Accessories</h3>
            <div v-html="getSolutionByLinkType('accessories').html_content" class="card-description"></div>
          </div>
          <div class="flex justify-start items-center">
            <span>Learn more</span>
            <div class="arrow-container">
              <img class="default-arrow" src="@/images/service-area-cards/Arrow.png" alt="Arrow">
              <img class="hover-arrow" src="@/images/service-area-cards/forward-arrows/container-accessories.png" alt="Arrow">
            </div>
          </div>
        </div>
      </a>

    </div>
  </div>
</div>
